import { detect } from "detect-browser";
const browser = detect();

const browserVersion = parseVersionString(browser.version);
const ignoreBrowserWarn = localStorage.getItem("ignoreBrowserWarn")
  ? true
  : false;

// APP BROWSER WARNING
// Show if Internet Explorer, Apple < 10.3, or DuckDuckGo Mobile
let isApple = browser.name === "ios" || browser.name === "safari";

if (
  !ignoreBrowserWarn &&
  (browser.name === "ie" ||
    navigator.userAgent.indexOf("DuckDuckGo") > -1 ||
    (isApple && browserVersion.major < 10) ||
    (isApple && browserVersion.major === 10 && browserVersion.minor <= 2))
) {
  (function () {
    // escape hatch
    if (!document.querySelector(".app-browser-warning")) return;

    const bodyEl = document.querySelector("body"),
      browserWarningApp = document.querySelector(".app-browser-warning"),
      browserWarningClose = document.querySelector(".browser-continue-button");

    bodyEl.classList.add("browser-warn");
    browserWarningApp.style.display = "block";

    browserWarningClose.addEventListener("click", function (e) {
      e.preventDefault();
      localStorage.setItem("ignoreBrowserWarn", true);
      browserWarningApp.style.display = "none";
      bodyEl.classList.remove("browser-warn");
    });
  })();
}

// HELPER: Parse Version String
function parseVersionString(str) {
  if (typeof str != "string") {
    return false;
  }
  var x = str.split(".");
  // parse from string or default to 0 if can't parse
  var maj = parseInt(x[0]) || 0;
  var min = parseInt(x[1]) || 0;
  var pat = parseInt(x[2]) || 0;
  return {
    major: maj,
    minor: min,
    patch: pat,
  };
}
